import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import * as diagnostics from '@/utils/diagnostics';

import { ERROR_CONTENT, ErrorCodes } from './constants';
import { ErrorOverlay } from './ErrorOverlay';

function getValidatedErrorCode(errorCode?: string): ErrorCodes {
  const errorCodeValues = Object.values(ErrorCodes) as string[];
  if (!errorCode || !errorCodeValues.includes(errorCode)) {
    diagnostics.error(
      'Failed error code lookup',
      new Error(
        `No error code mapping found for ${errorCode}; defaulting to ${ErrorCodes.UNKNOWN}`
      )
    );
    return ErrorCodes.UNKNOWN;
  }

  return errorCode as ErrorCodes;
}

export function PublicErrorPage() {
  const { errorCode: rawErrorCode } = useParams();
  const validatedErrorCode = getValidatedErrorCode(rawErrorCode);
  const { heading, body } = ERROR_CONTENT[validatedErrorCode];
  const trackUserEvent = useTrackUserEvent();

  useEffect(() => {
    if (validatedErrorCode === ErrorCodes.NOT_FOUND) return;
    trackUserEvent('error_page viewed', {
      errorCode: validatedErrorCode,
    });
  }, [validatedErrorCode, trackUserEvent]);

  return <ErrorOverlay heading={heading} body={body} />;
}
